export const InventoryConnectionTerminusTypeEnum = {
  None: 'None',
  Source: 'Source',
  Target: 'Target',
};

export const InventoryConnectionJobStatusEnum = {
  succeeded: 'succeeded',
  failed: 'failed',
  running: 'running',
  enqueued: 'enqueued',
};

export const InventoryConnectionValidStatusEnum = {
  active: 'active',
  inactive: 'inactive',
};
